import collectorsParadiseGoldCoastImage from '../Assets/events/collectors-paradise-gold-coast-2026.jpg';
import { Event } from '../types';

export { collectorsParadiseGoldCoastImage };

export const COLLECTORS_PARADISE_GOLD_COAST: Event = {
  id: 'promo-collectors-paradise-gold-coast-2026',
  title: "Collector's Paradise Gold Coast",
  description: "Collector's Paradise brings collectors, friends and family together for Pokemon, One Piece, trading cards, slabs, comics, games, anime merch, vendors, trading, pack battles and giveaways.",
  start: '2026-06-07T11:00:00+10:00',
  end: '2026-06-07T16:00:00+10:00',
  extendedProps: {
    location: '61 Cayuga St, Nerang QLD 4211',
    shop: 'PCYC Nerang',
    address: '61 Cayuga St, Nerang QLD 4211',
    descriptionUrl: 'https://www.trybooking.com/events/landing/1578181',
    offerUrl: 'https://www.trybooking.com/events/landing/1578181',
    image: collectorsParadiseGoldCoastImage,
    ticketCost: 'VIP Entry: $20 (11am - 4pm) | General Admission: $10 (12pm - 4pm) | Kids under 10: Free',
    tags: ['Pokemon', 'One Piece', 'Slabs', 'Booster Boxes', 'Anime Merch', 'Vendors', 'Collectibles'],
    eventType: 'Collector Event',
    region: 'QLD',
    stateCode: 'QLD',
    sourceKey: 'shows',
  },
};

export const ACTIVE_PROMOTED_EVENT = COLLECTORS_PARADISE_GOLD_COAST;
export const ACTIVE_PROMOTED_EVENT_BANNER_EXPIRES_AT = '2026-06-08T00:00:00+10:00';
export const PROMOTED_EVENTS: Event[] = [COLLECTORS_PARADISE_GOLD_COAST];
